import React from 'react';
import { ModalButton } from '@components/main-components/modals/ModalButton';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { useSecondaryModal } from '@context/secondaryModal';
import type { ChainType } from './SwitchChain';

export function SwitchChainInWalletModal({ chain }: { chain: ChainType }) {
  const { closeCancelModal } = useSecondaryModal();
  const networkLabel = (() => {
    switch (chain) {
      case 'eth':
        return 'Ethereum';
      case 'optimism':
        return 'Optimism';
      case 'base':
        return 'Base';
      default:
        return 'Ghost Network';
    }
  })();

  const onClose = () => {
    closeCancelModal();
  };

  return (
    <StandardModal
      closeModal={onClose}
      title="Switch chain in wallet"
      bodyWithoutPaddingBottom
      body={
        <div className="flex flex-col gap-6">
          <p className="font-base text-base800">
            Open your wallet app and switch to {networkLabel} chain to continue.
          </p>
          <ModalButton label="Done" variant="primary" onClick={onClose} />
        </div>
      }
    />
  );
}
